const luhnChecksum = (code) => {
    const codeLength = code.length;
    const isPair = codeLength % 2;
    let sum = 0;
    for (let i = codeLength - 1; i >= 0; i--) {
        let number = parseInt(code.charAt(i));
        if (i % 2 === isPair) {
            number *= 2;
        }
        if (number > 9) {
            number -= 9;
        }
        sum += number;
    }
    return sum % 10;
};

/* luhnCalculate
 * Return a full code (including check digit), from the specified partial code (without check digit).
 */
const luhnCalculate = (partcode) => {
    const checksum = luhnChecksum(`${partcode}0`);
    return checksum === 0 ? `${partcode}0` : `${partcode}${10 - checksum}`;
};

/* luhnValidate
 * Return true if specified code (with check digit) is valid.
 */
const luhnValidate = (fullcode) => {
    return luhnChecksum(fullcode) === 0;
};
export { luhnChecksum, luhnCalculate, luhnValidate };